import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Shambhu Cabs</title>
      </Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3>Privacy Policy</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At <b>Shambhu Cabs</b>, we value your trust and are committed to maintaining the privacy 
                and confidentiality of your personal information. This Privacy Policy explains how we collect, 
                use, store, and protect your information when you book a cab or interact with our services.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>

                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  When you book a ride, we may collect details such as your name, phone number, pickup and drop 
                  location, payment information, and any special travel requirements.
                </p>

                <p className="highlight darkcolor">2. Usage Information:</p>
                <p>
                  We may collect data about how you interact with our website or booking system, including device 
                  details, IP address, browser type, and pages visited.
                </p>

                <p className="highlight darkcolor">3. Location Information:</p>
                <p>
                  With your permission, we may collect your real-time location to assign drivers accurately and 
                  improve travel efficiency.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>

                <p className="highlight darkcolor">1. To Provide Cab Services:</p>
                <p>
                  We use your information to confirm bookings, assign drivers, manage pickups, and deliver smooth 
                  transportation services.
                </p>

                <p className="highlight darkcolor">2. To Improve Customer Experience:</p>
                <p>
                  Your data helps us analyze performance, enhance navigation accuracy, and improve service quality.
                </p>

                <p className="highlight darkcolor">3. Communication:</p>
                <p>
                  We may contact you for booking updates, driver details, OTP verification, or customer support-related matters.
                </p>

                <p className="highlight darkcolor">4. Offers & Marketing:</p>
                <p>
                  With your consent, we may send promotional messages, discount offers, and service updates.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing and Disclosure:</p>

                <p className="highlight darkcolor">1. With Drivers & Service Partners:</p>
                <p>
                  Basic details such as name, pickup location, and contact number may be shared with our assigned drivers 
                  to successfully complete your booking.
                </p>

                <p className="highlight darkcolor">2. Legal Requirements:</p>
                <p>
                  We may disclose information if required by law, government authorities, or to protect the rights and 
                  safety of Shambhu Cabs and its customers.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We use secure digital systems and industry-standard practices to protect your information. However, 
                  no online transmission is completely risk-free.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You can request access, correction, or deletion of your personal data. You may also unsubscribe from 
                  promotional communications at any time.
                </p>

                <p className="highlight darkcolor">Updates to this Privacy Policy:</p>
                <p>
                  Shambhu Cabs may modify this policy occasionally. Updated versions will be posted on our official website.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions regarding our Privacy Policy, please contact us:</p>

            <ul>
              <li><b>Phone:</b> <a href="tel:+919819399797">+91 9819399797</a></li>
              <li><b>Email:</b> <a href="mailto:bookings@shambhucabs.com">bookings@shambhucabs.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
